import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatTextdirectionRToLIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_textdirection_r_to_l"}/>
}
